import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@/design-system/atoms/Icons/Icon';

import styles from './AudioListItem.module.scss';

const AudioPlayButton = (props) => {
    const { onTogglePlay, isPlaying } = props;

    return (
        <div className={classnames(styles[`audio__play`])}>
            <button onClick={onTogglePlay}>
                <Icon name={isPlaying ? 'pause' : 'play'} size={25} />
            </button>
        </div>
    );
};

AudioPlayButton.propTypes = {
    /**
     * Required function that start the audio
     */
    onTogglePlay: PropTypes.func.isRequired,
    /**
     * Required boolean to switch the button look and feel
     */
    isPlaying: PropTypes.bool.isRequired,
};

export default AudioPlayButton;
